require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

(function (global, factory) {
  if ('function' == typeof define && define.amd) define(['exports'], factory);else if ('undefined' != typeof exports) factory(exports);else {
    var mod = {
      exports: {}
    };
    factory(mod.exports), global.help = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, '__esModule', {
    value: !0
  }), exports["default"] = function () {
    var name = this.config.name,
        firstBig = function firstBig(word) {
      return word.charAt(0).toUpperCase() + word.substr(1);
    },
        parts = [],
        groups = {
      options: !0,
      examples: !0
    };

    for (var group in groups) {
      0 < this.details[group].length || (groups[group] = !1);
    }

    var optionHandle = groups.options ? '[options] ' : '',
        value = 'string' == typeof this.config.value ? ' ' + this.config.value : '';

    for (var _group in parts.push(['', 'Usage: ' + this.printMainColor(name) + ' ' + this.printSubColor(optionHandle + value), '']), groups) {
      groups[_group] && (parts.push(['', firstBig(_group) + ':', '', '']), 'examples' == _group ? parts.push(this.generateExamples()) : parts.push(this.generateDetails(_group)), parts.push(['', '']));
    }

    var output = '',
        _iteratorNormalCompletion = !0,
        _didIteratorError = !1,
        _iteratorError = void 0;

    try {
      for (var _step, part, _iterator = parts[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = !0) {
        part = _step.value, output += part.join('\n  ');
      }
    } catch (err) {
      _didIteratorError = !0, _iteratorError = err;
    } finally {
      try {
        !_iteratorNormalCompletion && _iterator["return"] && _iterator["return"]();
      } finally {
        if (_didIteratorError) throw _iteratorError;
      }
    }

    groups.options || (output = 'No options available');
    var usageFilter = this.config.usageFilter;
    return 'function' == typeof usageFilter && (output = usageFilter(output) || output), output;
  };
});